import React from "react";
import { useLocation } from "react-router-dom";
import SaudiRegionsAndCities from "../SaudiRegionsAndCities/SaudiRegionsAndCities";
import CompanySelect from "../CompanySelect/CompanySelect";

export default function BranchInputs({ onInputChange, branchData, setSelectedCompany, passedCompanyId }) {
  const location = useLocation();
  const isAddBranchPage = location.pathname.endsWith("/AddBranch");

  const handleChange = (e) => {
    const { name, value } = e.target;
    onInputChange(name, value);
  };

  const handleCompanySelect = (companyId) => {
    onInputChange("company_id", companyId);
  };

  return (
    <>
      <section className="row mb-5">
        <h4>
          <span>بيانات الفرع</span>
        </h4>
        <div className="col-md-6 mt-3 mb-2">
          <div>
            <label htmlFor="branchName">اسم الفرع</label>
            <input type="text" name="name" value={branchData?.name || ""} placeholder="اسم الفرع" id="name" className="form-control" onChange={handleChange} />
          </div>
        </div>
        <div className="col-md-6 mt-3">
          <div>
            <label htmlFor="managerName">اسم المدير</label>
            <input type="text" name="manager_name" value={branchData?.manager_name || ""} placeholder="اسم المدير" id="managerName" className="form-control" onChange={handleChange} />
          </div>
        </div>
        {branchData.companyId == "" && (
          <div className="col-md-6 mt-3">
            <CompanySelect onSelect={handleCompanySelect} setSelectedCompany={setSelectedCompany} />
          </div>
        )}
      </section>

      <section className="row mb-5">
        <h4>
          <span>عنوان الفرع</span>
        </h4>
        <SaudiRegionsAndCities branchData={branchData} handleChange={onInputChange} />
      </section>

      <section className="row mb-3">
        <h4>
          <span>بيانات التواصل</span>
        </h4>
        <div className="col-md-6 mb-2">
          <div>
            <label htmlFor="phone" className="mt-3">
              رقم الهاتف
            </label>
            <input type="text" name="phone" value={branchData?.phone || ""} placeholder="رقم الهاتف" id="phone" className="form-control" onChange={handleChange} />
          </div>
        </div>
        <div className="col-md-6">
          <div>
            <label htmlFor="email" className="mt-3">
              البريد الاليكتروني
            </label>
            <input type="email" name="email" value={branchData?.email || ""} placeholder="البريد الاليكتروني" id="email" className="form-control" onChange={handleChange} />
          </div>
        </div>
      </section>
    </>
  );
}
